<template>
  <div class="list-table-column-material-type">
    {{ getTypeName(scope.row.materialType) }}
  </div>
</template>

<script>
export default {
  name: 'ListTableColumnMaterialType',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    getTypeName (type) {
      let map = [{
        label: '全部',
        value: 0
      }, {
        label: '文档',
        value: 1
      }, {
        label: '表格',
        value: 2
      }, {
        label: 'PDF',
        value: 3
      }, {
        label: '幻灯片',
        value: 5
      }, {
        label: '图片',
        value: 6
      }, {
        label: '音频',
        value: 7
      }, {
        label: '视频',
        value: 8
      }]
      let name = ''
      map.forEach(item => {
        if (item.value === type) {
          name = item.label
        }
      })
      return name
    }
  }
}
</script>
